import React from 'react';
import _ from 'lodash';
import { useRecoilValue } from 'recoil';
import { useTranslation } from 'react-i18next';
import {
  faCog,
  faUniversity,
  faUser,
  faUsers,
  faHome,
  faSignOut,
  faFileAlt,
  faUpload,
  faHistory,
  faBus,
  faReceipt,
  faFile,
  faFolderOpen,
  faCarBus,
  faGlobe,
  faCar,
  faChartLine,
  faHeartRate,
  faHeartbeat
} from '@fortawesome/pro-duotone-svg-icons';
import { userAtom, userPrivilagesAtom, userOperatorsAtom } from '../../../atoms/Atoms';
import MainPage from '../../shared-components/main-page/MainPage';
import { H1 } from '../../shared-components/typography/Title';
import HomeCard from './shared-components/HomeCard';
import envConfig from '../../../envConfig';

function Home() {
  const user = useRecoilValue(userAtom);
  const { t } = useTranslation();
  const userPrivilages = useRecoilValue(userPrivilagesAtom);
  const userOperators = useRecoilValue(userOperatorsAtom);

  return (
    <MainPage>
      <H1 className="mb-4" text={t('home_intro')} />
      <div className="grid sm:grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
        {userPrivilages?.hasGlobalPrivilages && (
          <HomeCard
            icon={faCog}
            title={t('server_config')}
            description={t('server_config_desc')}
            route="/serverconfig"
          />
        )}
        {userPrivilages?.hasAdminPrivilages && (
          <>
            {/* <HomeCard
              icon={faUniversity}
              title={t('operators')}
              description={t('operators_desc')}
              route="/operators"
            /> */}
            {/* <HomeCard
              icon={faFileAlt}
              title={t('storage_file_processes')}
              description={t('storage_file_processes_desc')}
              route="/fileprocesses"
            /> */}
          </>
        )}
        {userPrivilages?.hasPipelineHealthPrivilages && (
          <HomeCard
            icon={faHeartbeat}
            title={t('pipeline_health')}
            description={t('pipeline_health_desc')}
            route="/pipeline-health"
          />
        )}
        {userPrivilages?.hasCustomerSupportPrivilages && (
          <HomeCard
            icon={faUsers}
            title={t('users')}
            description={t('users_desc')}
            route="/users"
          />
        )}
        {userPrivilages?.hasDashboardAnalyticsPrivilages && (
          <HomeCard
            icon={faChartLine}
            title={t('dashboard_analytics')}
            description={t('dashboard_analytics_desc')}
            route="/dashboard/analytics"
          />
        )}
        {(userPrivilages?.hasGlobalPrivilages ||
          _.filter(userOperators, (op) => op.id === envConfig.HmsOperatorId).length > 0) && (
          <>
            <HomeCard
              icon={faReceipt}
              title={`HMS - ${t('trips')}`}
              description={t('hms_trips_desc')}
              route="/hms/trips"
            />
            <HomeCard
              icon={faGlobe}
              title="HMS - NTD"
              description={t('hms_ntd_desc')}
              route="/hms/ntd"
            />
          </>
        )}
        {(userPrivilages?.hasGlobalPrivilages ||
          _.filter(userOperators, (op) => op.id === envConfig.TransdevOperatorId).length > 0) && (
          <>
            <HomeCard
              icon={faReceipt}
              title={`Transdev - ${t('invoices')}`}
              description={t('compare_invoices_desc')}
              route="/transdev/invoice"
            />
            <HomeCard
              icon={faFile}
              title={`Transdev - ${t('farebox_collection_submissions')}`}
              description={t('farebox_collection_submissions_desc')}
              route="/transdev/farebox"
            />
            <HomeCard
              icon={faFolderOpen}
              title={`Transdev - ${t('incidentals')}`}
              description={t('incidentals_submissions_desc')}
              route="/transdev/incidentals"
            />
            <HomeCard
              icon={faCarBus}
              title={`Transdev - ${t('special_services')}`}
              description={t('special_services_desc')}
              route="/transdev/specialservices"
            />
            <HomeCard
              icon={faCar}
              title={`Transdev - ${t('trips')}`}
              description={t('transdev_trips_desc')}
              route="/transdev/trips"
            />
          </>
        )}
        {(userPrivilages?.hasGlobalPrivilages || (userPrivilages?.hasOperatorAdminPrivilages &&
        _.filter(userOperators, (op) => op.id === envConfig.TransdevOperatorId).length > 0)) && (
          <HomeCard
            icon={faFile}
            title={`Transdev - ${t('law_123')}`}
            description={t('law_123_desc')}
            route="/transdev/law123"
          />
        )}
        {(userPrivilages?.hasGlobalPrivilages ||
          _.filter(userOperators, (op) => op.id === envConfig.SonnellOperatorId).length > 0) && (
          <>
            <HomeCard
              icon={faReceipt}
              title={`Sonnell - ${t('invoices')}`}
              description={t('compare_invoices_desc')}
              route="/sonnell/invoice"
            />
            <HomeCard
              icon={faFile}
              title={`Sonnell - ${t('farebox_collection_submissions')}`}
              description={t('farebox_collection_submissions_desc')}
              route="/sonnell/farebox"
            />
            <HomeCard
              icon={faFolderOpen}
              title={`Sonnell - ${t('incidentals')}`}
              description={t('incidentals_submissions_desc')}
              route="/sonnell/incidentals"
            />
            <HomeCard
              icon={faCarBus}
              title={`Sonnell - ${t('special_services')}`}
              description={t('special_services_desc')}
              route="/sonnell/specialservices"
            />
            <HomeCard
              icon={faCar}
              title={`Sonnell - ${t('trips')}`}
              description={t('sonnell_trips_desc')}
              route="/sonnell/trips"
            />
          </>
        )}
        {(userPrivilages?.hasGlobalPrivilages || (userPrivilages?.hasOperatorAdminPrivilages &&
        _.filter(userOperators, (op) => op.id === envConfig.SonnellOperatorId).length > 0)) && (
          <HomeCard
            icon={faFile}
            title={`Sonnell - ${t('law_123')}`}
            description={t('law_123_desc')}
            route="/sonnell/law123"
          />
        )}



        {(userPrivilages?.hasGlobalPrivilages || (userPrivilages?.hasOperatorAdminPrivilages &&
        _.filter(userOperators, (op) => op.id === envConfig.AmaOperatorId).length > 0)) && (
          <>
            {/* <HomeCard
              icon={faBus}
              title={`AMA - ${t('dashboard')}`}
              description={t('ama_dashboard_desc')}
              route="/ama/dashboard"
            /> */}
            <HomeCard
              icon={faBus}
              title={`AMA - ${t('holidays')}`}
              description={t('holidays_desc')}
              route="/ama/holidays"
            />
          </>
        )}
        {(userPrivilages?.hasGlobalPrivilages || (userPrivilages?.hasRouteValidationPrivilages &&
        _.filter(userOperators, (op) => op.id === envConfig.AmaOperatorId).length > 0)) && (
          <HomeCard
            icon={faBus}
            title={`AMA - ${t('route_validation')}`}
            description={t('route_validation_desc')}
            route="/ama/routevalidation"
          />  
        )}
        {/* <HomeCard
          icon={faUpload}
          title={t('document_upload')}
          description={t('document_upload_desc')}
          route="/document-upload"
        />
        <HomeCard
          icon={faHistory}
          title={t('upload_history')}
          description={t('upload_history_desc')}
          route="/upload-history"
        /> */}
        
      </div>
    </MainPage>
  );
}

export default Home;
